angular.module('CarsSaraBo').factory('AlfredService', ['$resource', function($resource) {
  return $resource('/../rest/alfred/',
  	{ country : '@country' },
    {
      countries : { method : 'GET', url: '../rest/alfred/country', isArray:true },
      creditCards : { method : 'GET', url: '../rest/alfred/creditCard/:country', isArray:true }    }
	)}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/alfred_service.js
// module id = 837
// module chunks = 3